// // Increase/decrease font size
// var getsessionText = window.sessionStorage.getItem("textsize");
// var getsessionCalm = window.sessionStorage.getItem("calm");
// document.documentElement.style.fontSize = parseInt(getsessionText) + "px";
// if (getsessionCalm == 1) {
//     document.documentElement.classList.add("calm");
//     document.getElementById('calmModeToggle').checked = true;
//     document.querySelector('.calmModeToggleLabel').textContent = 'Colour mode: Calm';

// } else {
//     document.documentElement.classList.remove("calm");
//     document.getElementById('calmModeToggle').checked = false;
//     document.querySelector('.calmModeToggleLabel').textContent = 'Colour mode: Vivid';

// }

// // Toggle calm color scheme
// document.getElementById('calmModeToggle').addEventListener('change', function() {
//     console.log('calmModeToggle - clicked');
//     if (document.documentElement.classList.contains("calm")) {
//         window.sessionStorage.setItem("calm", 0);
//         document.documentElement.classList.toggle("calm");
//         document.querySelector('.calmModeToggleLabel').textContent = 'Colour mode: Vivid';
//     } else {
//         window.sessionStorage.setItem("calm", 1);
//         document.documentElement.classList.toggle("calm");
//         document.querySelector('.calmModeToggleLabel').textContent = 'Colour mode: Calm';
//     }
// });



// let curSize = '';
// document.getElementById('increasetext').addEventListener('click', function() {
//     curSize = parseInt(getComputedStyle(document.documentElement).fontSize) + 2;
//     window.sessionStorage.setItem("textsize", curSize);
//     if (curSize <= 32)
//         document.documentElement.style.fontSize = curSize + "px";
// });

// document.getElementById('resettext').addEventListener('click', function() {
//     if (curSize != '16px')
//         document.documentElement.style.fontSize = '16px';
//     window.sessionStorage.setItem("textsize", '16px');
// });



// Correct accessibility attributes in the booking widget and its shadow roots.
document.addEventListener('DOMContentLoaded', function () {
  var observedRoots = new WeakSet();
  function fixBookingAttributes(root) {
    root.querySelectorAll('img.BW_mb:not([alt])').forEach(function (image) {
      image.setAttribute('alt', '');
    });
    root.querySelectorAll('input[type="password"][autocomplete="password"]').forEach(function (input) {
      input.setAttribute('autocomplete', 'current-password');
    });
    if (!observedRoots.has(root)) {
      observedRoots.add(root);
      new MutationObserver(function () { fixBookingAttributes(root); }).observe(root, {childList: true, subtree: true});
    }
    root.querySelectorAll('bewell-booker-modal, bewell-widget, bewell-booker-inline').forEach(function (widget) {
      if (widget.shadowRoot) fixBookingAttributes(widget.shadowRoot);
    });
  }
  fixBookingAttributes(document.body);
  ['bewell-booker-modal', 'bewell-widget', 'bewell-booker-inline'].forEach(function (tag) {
    customElements.whenDefined(tag).then(function () { fixBookingAttributes(document.body); });
  });
});

// Desktop mega menus open on hover; native details retain touch and keyboard controls.
document.addEventListener('DOMContentLoaded', function () {
  var menus = document.querySelectorAll('ul.mainmenu .header-mega-menu details');
  menus.forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (details.open) menus.forEach(function (other) { if (other !== details) other.open = false; });
    });
    var closeTimer;
    details.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      if (window.matchMedia('(hover: hover)').matches) details.open = true;
    });
    details.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        if (!details.contains(document.activeElement)) details.open = false;
      }, 200);
    });
    details.addEventListener('focusout', function (event) {
      if (!details.contains(event.relatedTarget) && !details.matches(':hover')) details.open = false;
    });
    details.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        clearTimeout(closeTimer);
        details.querySelector('summary').focus();
        details.open = false;
      }
    });
    var backdrop = document.querySelector('.branch-menu-backdrop');
    if (backdrop) backdrop.addEventListener('click', function () {
      if (!details.open) return;
      clearTimeout(closeTimer);
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
});

// Second-level panels slide over the open drawer without replacing it.
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('pointerdown', function () { document.body.classList.add('using-pointer'); });
  document.addEventListener('touchstart', function () { document.body.classList.add('using-pointer'); }, {passive: true});
  document.addEventListener('keydown', function () { document.body.classList.remove('using-pointer'); });
  var main = document.getElementById('offcanvasExample');
  if (!main || !window.bootstrap || !bootstrap.Offcanvas) return;
  main.querySelectorAll('ul.mobilemenu > li').forEach(function (item, index) {
    if (/^book now$/i.test(item.firstElementChild.textContent.trim())) item.classList.add('mobile-book-now');
    var details = item.querySelector(':scope > details');
    var link = details ? details.querySelector('summary') : item.firstElementChild;
    var children = details ? details.querySelector('.branch-menu-panel') : item.querySelector(':scope > ul');
    if (!link || !children || !children.children.length) return;
    var panel = document.createElement('section');
    panel.className = 'site-menu mobile-submenu';
    panel.inert = true;
    panel.id = 'mobile-submenu-' + index;
    panel.tabIndex = -1;
    panel.setAttribute('aria-labelledby', panel.id + '-title');
    panel.appendChild(main.querySelector('.offcanvas-header').cloneNode(true));
    var body = document.createElement('div');
    body.className = 'offcanvas-body';
    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'mobile-menu-back';
    back.textContent = '‹ Back';
    back.setAttribute('data-bs-target', '#offcanvasExample');
    back.setAttribute('aria-controls', 'offcanvasExample');
    body.appendChild(back);
    var title = document.createElement('h2');
    title.id = panel.id + '-title';
    title.textContent = link.textContent.trim();
    body.appendChild(title);
    if (link.tagName === 'A') {
      var overview = document.createElement('li');
      var overviewLink = link.cloneNode(true);
      overviewLink.textContent = 'All ' + title.textContent;
      overview.appendChild(overviewLink);
      children.prepend(overview);
    }
    children.classList.remove('dropdown-menu');
    children.classList.add('mobile-submenu-links');
    body.appendChild(children);
    panel.appendChild(body);
    main.appendChild(panel);
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'nav-link mobile-menu-next';
    trigger.textContent = title.textContent;
    trigger.setAttribute('data-bs-target', '#' + panel.id);
    trigger.setAttribute('aria-controls', panel.id);
    trigger.setAttribute('aria-expanded', 'false');
    var mainHeader = main.querySelector(':scope > .offcanvas-header');
    var mainBody = main.querySelector(':scope > .offcanvas-body');
    function closePanel(focus) {
      panel.classList.remove('is-open');
      panel.inert = true;
      mainHeader.inert = mainBody.inert = false;
      trigger.setAttribute('aria-expanded', 'false');
      if (focus) trigger.focus();
    }
    trigger.addEventListener('click', function () {
      panel.inert = false;
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      back.focus();
      mainHeader.inert = mainBody.inert = true;
    });
    back.addEventListener('click', function () { closePanel(true); });
    panel.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.stopPropagation();
        closePanel(true);
      }
    });
    main.addEventListener('hidden.bs.offcanvas', function () { closePanel(false); });
    if (details) details.replaceWith(trigger);
    else link.replaceWith(trigger);
  });
});

// Filter only the menu items already authorised and rendered by Joomla.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.branch-menu-panel').forEach(function (panel) {
    var input = panel.querySelector('input[type="search"]');
    var noun = panel.dataset.menuNoun || 'branch';
    var plural = panel.dataset.menuPlural || 'branches';
    input.addEventListener('input', function () {
      var query = input.value.trim().toLocaleLowerCase();
      var count = 0;
      panel.querySelectorAll('.branch-menu-group').forEach(function (group) {
        var visible = 0;
        group.querySelectorAll('.branch-menu-item').forEach(function (item) {
          item.hidden = !item.textContent.toLocaleLowerCase().includes(query);
          if (!item.hidden) visible++;
        });
        group.hidden = visible === 0;
        count += visible;
      });
      panel.querySelector('.branch-menu-empty').hidden = count !== 0;
      panel.querySelector('.branch-menu-status').textContent = count + ' ' + (count === 1 ? noun : plural) + ' found';
    });
  });
});
